class StickyHeader extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header') || this.closest('[id^="shopify-section"]') || this
    this.headerWrapper = document.querySelector('.header-wrapper')
    this.announcementBar = document.querySelector('.announcement-bar')
    this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : null
    this.details = this.querySelectorAll(
      '.list-menu details-disclosure details'
    )
    this.detailsDesktop = this.querySelectorAll('.has-submenus details')
    this.detailsMobile = this.querySelectorAll('.menu-drawer__details--child')
    this.body = document.body
    this.root = document.documentElement

    this.openSubmenu = false

    this.submenuClass = 'is-submenu-open'
    this.stickyClass = 'is-sticky'
    this.bodyScrolledClass = 'body-scrolled'
    this.openDrawerClass = 'is-drawer-open'

    this.headerBounds = {}
    this.currentScrollTop = 0

    this.onScrollHandler = this.onScroll.bind(this)
    this.handleHeaderSpacing()

    window.addEventListener('scroll', this.onScrollHandler, false)
    window.addEventListener(
      'resize',
      debounce(() => {
        if (this.announcementBar != null) {
          this.announcementBarHeight = this.announcementBar.offsetHeight
        }
        this.onScroll()
        this.openNavigation()
        this.resetAnimation()
        this.handleHeaderSpacing()
      }),
      200
    )

    this.details.forEach((item) => {
      item.addEventListener('toggle', (event) => {
        this.details.forEach((el) => {
          if (el.open) {
            this.openSubmenu = true
            // Close search
            document.querySelector(':popover-open')?.hidePopover()
          }
        })

        if (this.openSubmenu) {
          this.classList.add(this.submenuClass)
        } else {
          this.classList.remove(this.submenuClass)
        }
        this.openSubmenu = false
      })
    })

    this.createObserver()
    this.onScroll()
    this.listenForInjectedContent()
    this.openNavigation()
    this.resetAnimation()
  }

  listenForInjectedContent() {
    const slot = this.announcementBar?.querySelector('[data-injected-content]')
    if (!slot) return

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : null
          this.onScroll()
        }
      })
    })
    observer.observe(slot, { childList: true })
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 100) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }

  handleHeaderSpacing() {
    const headerHeight = this.querySelector('.header').offsetHeight
    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    )
  }

  resetAnimation() {
    this.detailsDesktop.forEach((item) => {
      item.addEventListener('toggle', (event) => {
        if (window.matchMedia('(min-width: 990px)')) {
          let el = item.querySelector('.header__submenu--child-content')
          if (el) el.offsetHeight
        }
      })
    })

    this.detailsMobile.forEach((item) => {
      item.addEventListener('toggle', (event) => {
        if (window.matchMedia('(max-width: 989px)')) {
          let el = item.querySelector('.menu-drawer__menu .list-menu')
          if (el) el.offsetHeight
        }
      })
    })
  }

  openNavigation() {
    if (window.matchMedia('(min-width: 990px)')) {
      this.detailsDesktop.forEach((trigger) => {
        let disclosure = trigger.closest('details-disclosure')
        disclosure.addEventListener('mouseenter', function () {
          trigger.setAttribute('open', true)
          trigger.classList.add('details-opening')
        })

        disclosure.addEventListener('mouseleave', () => {
          trigger.classList.remove('details-opening')
          this.closeAnimation(trigger)

          if (window.wheel_indicator !== null) {
            window.wheel_indicator.turnOn()
            window.wheel_indicator._isWorking = true
          }
        })

        trigger.addEventListener('click', function (e) {
          if (!e.target.closest('.header__submenu')) {
            const state = trigger.hasAttribute('open')
            if (state) {
              trigger.removeAttribute('open')
            } else {
              trigger.setAttribute('open', true)
            }
          }
        })
      })
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this.header)
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    this.currentScrollTop = scrollTop

    if (
      this.announcementBar != null &&
      !this.announcementBar.classList.contains('is-hidden')
    ) {
      if (this.currentScrollTop > this.announcementBarHeight) {
        this.classList.add(this.stickyClass)
        document.body.classList.add(this.bodyScrolledClass)
        this.announcementBar.classList.add('is-hidden')
        this.root.style.setProperty(
          '--bar-height',
          `0px`
        )
      } else {
        this.classList.remove(this.stickyClass)
        document.body.classList.remove(this.bodyScrolledClass)
        this.root.style.setProperty('--bar-height', `${this.announcementBarHeight}px`)
      }
    } else {
      if (this.currentScrollTop >= 1) {
        this.classList.add(this.stickyClass)
        document.body.classList.add(this.bodyScrolledClass)
        this.root.style.setProperty(
          '--bar-height',
          `0px`
        )
      } else {
        this.classList.remove(this.stickyClass)
        document.body.classList.remove(this.bodyScrolledClass)
        if (this.announcementBar) {
          this.announcementBar.classList.remove('is-hidden')
          this.root.style.setProperty('--bar-height', `${this.announcementBarHeight}px`)
        }
      }
    }
  }

  hide() {
    this.closeMenuDisclosure()
    this.closeSearchModal()
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('details-disclosure')
    this.disclosures.forEach((disclosure) => disclosure.close())
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal')
    this.searchModal.close(false)
  }
}

customElements.define('sticky-header', StickyHeader)
